import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Component, OnDestroy, OnInit } from '@angular/core';

import { UpgradeFeemiumDialogComponent } from '../upgrade-feemium-dialog/upgrade-feemium-dialog.component';
import { LoginModel } from 'src/app/models/login.model';
import { StorageKeyEnum } from 'src/app/core/StorageKeyEnum';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-sidebar-freemium-dialog',
  templateUrl: './sidebar-freemium-dialog.component.html',
  styleUrls: ['./sidebar-freemium-dialog.component.scss']
})
export class SidebarFreemiumDialogComponent implements OnInit,OnDestroy {
  userInfo: LoginModel;
  private destroy$ = new Subject<void>();
  constructor(
    private dialog: MatDialog,
    private dialogRef: MatDialogRef<SidebarFreemiumDialogComponent>,
     ) { }


  ngOnInit(): void {
    this.userInfo = JSON.parse(
      localStorage.getItem(StorageKeyEnum.User)
    );
  }

  upgrade() {
    this.dialogRef.close();
    this.dialog.open(UpgradeFeemiumDialogComponent, {
      width: '500px',
    })
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.unsubscribe();
  }
}
